import * as React from 'react';

import { Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import QRCode from 'components/qrcode';
import { primitive } from 'styles/constants/primitives';

interface IWhopperQrCodeWidgetProps {
  shortCode?: string;
}

const WhopperQrCodeWidget: React.FC<IWhopperQrCodeWidgetProps> = ({ shortCode }) => {
  const { formatMessage } = useIntl();

  const barcodeOptions = {
    margin: 1,
    width: 180,
    color: {
      dark: primitive.$black,
      light: primitive.$white,
    },
  };

  if (!shortCode) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text
        style={styles.title}
        accessibilityLabel={formatMessage({
          id: 'whopperQrTitle',
        })}
      >
        {formatMessage({
          defaultMessage: 'Or scan this QR code',
          id: 'whopperQrTitle',
        })}
      </Text>
      <Text
        style={styles.subtitle}
        accessibilityLabel={formatMessage({
          defaultMessage: 'Cashier can scan this code',
          id: 'whopperQrSubtitle',
        })}
      >
        {formatMessage({
          defaultMessage: 'Cashier can scan this code',
          id: 'whopperQrSubtitle',
        })}
      </Text>
      <View style={styles.qrContainer}>
        <QRCode testID="whopper-qr-code" barcode={shortCode || ''} options={barcodeOptions} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#F5A623',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    alignItems: 'center',
    paddingTop: 20,
    paddingBottom: 60,
    paddingHorizontal: 24,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 8,
    textAlign: 'center',
    color: primitive.bk.$bbqBrown,
    fontFamily: 'Flame',
  },
  subtitle: {
    fontSize: 14,
    fontWeight: '400',
    marginBottom: 24,
    textAlign: 'center',
    color: primitive.bk.$bbqBrown,
    fontFamily: 'Flame Sans',
  },
  qrContainer: {
    padding: 24,
    backgroundColor: '#fff',
    borderRadius: 16,
  },
});

export default WhopperQrCodeWidget;
